// *******************************************************************************
// Form handling
// *******************************************************************************

const handleForm = (form, formAction) => {
  const formParent = form.closest('[data-parent]');
  const formAlertError = formParent.querySelector('.form-component__alert-error');
  const passwordField = document.getElementById('setPassword');

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {},
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', () => {
      grecaptcha.ready(async () => {
        formParent.classList.add('show-loader');
        try {
          let requiredInputs = '';
          form.querySelectorAll('.form-component__inner input, .form-component__inner textarea').forEach((input) => {
            if (input.type !== 'hidden' && input.hasAttribute('required')) {
              requiredInputs += `${input.name}|`;
            }
          });
          requiredInputs = requiredInputs.slice(0, -1);

          await onFormSubmit({
            formData: {
              ...getFormValue(form, fv),
              id: localData.id,
              lang: localData.lang,
              requiredInputs,
            },
            recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
            recaptchaAction: formAction,
          });

          formParent.classList.remove('show-loader');
          formParent.classList.add('show-thankyou');
          if (formParent.closest('.form-modal')) {
            const formModalEle = formParent.closest('.form-modal');
            formModalEle.classList.add('show-thankyou');
          }
        } catch (error) {
          console.error(error);
          formParent.classList.remove('show-loader');
          formParent.classList.add('show-error');
          formAlertError.classList.remove('hide');
          formAlertError.innerHTML = error.response.data.data.msg;
        }
      });
    });

  if (passwordField) {
    const getValidationElem = (parent, selector) => parent.querySelector(selector);
    const passwordFieldParent = passwordField.closest('.mod-input');
    const [notEmptyMsg, capitalLettersMsg, lowerCaseMsg, digitMsg, minCharactersMsg, specialCharacter] = [
      '[data-fv-not-empty___message]',
      '[data-password-capital-letters]',
      '[data-password-lowercase]',
      '[data-password-digit]',
      '[data-password-min-characters]',
      '[data-password-special-character]',
    ].map((query) => getValidationElem(passwordFieldParent, query));
    const allValidationItems = passwordFieldParent.querySelectorAll('.mod-input__password-validation-item');
    const confirmPassValidationElem = document.getElementById('confirmResetPassword');

    const toggleValidationClass = (elem, toggle) => {
      passwordField.closest('.mod-input').classList.toggle('is-validation-failed', toggle);
      elem.classList.toggle('is-failed', toggle);
      elem.classList.toggle('is-passed', !toggle);
    };

    const strongPassword = () => ({
      // eslint-disable-next-line consistent-return
      validate(input) {
        const password = input.value;
        const lowercaseRegex = /[a-z]/;
        const uppercaseRegex = /[A-Z]/;
        const numberRegex = /\d/;
        const specialCharRegex = /[!@#$%^&*()_\-+=<>?]/;
        let isValid = true;

        if (password === '') {
          isValid = false;
          allValidationItems.forEach((elem) => {
            elem.classList.remove('is-failed');
            elem.classList.remove('is-passed');
          });
          passwordField.closest('.mod-input').classList.remove('is-validation-failed');
        }

        [
          {
            validator: !uppercaseRegex.test(password),
            element: capitalLettersMsg,
          },
          {
            validator: !lowercaseRegex.test(password),
            element: lowerCaseMsg,
          },
          {
            validator: !numberRegex.test(password),
            element: digitMsg,
          },
          {
            validator: !specialCharRegex.test(password),
            element: specialCharacter,
          },
          {
            validator: password.length < 8,
            element: minCharactersMsg,
          },
        ].forEach(({ validator, element }) => {
          if (validator) {
            isValid = false;
          }

          toggleValidationClass(element, validator);
        });

        if (isValid) {
          return {
            valid: true,
          };
        }
      },
    });

    const setPasswordValidators = {
      validators: {
        notEmpty: {
          message: notEmptyMsg.getAttribute('data-fv-not-empty___message'),
        },
        // checkPassword is name of new validator
        checkPassword: {
          message: notEmptyMsg.getAttribute('data-fv-not-empty___message'),
        },
      },
    };

    if (confirmPassValidationElem) {
      const confirmPassValidationMsg = confirmPassValidationElem.getAttribute('data-fv-identical___message');

      const confirmResetPasswordValidators = {
        validators: {
          identical: {
            compare() {
              return form.querySelector('[name="setPassword"]').value;
            },
            message: confirmPassValidationElem ? confirmPassValidationMsg : '',
          },
        },
      };

      fv.addField('confirmResetPassword', confirmResetPasswordValidators);
    }

    fv.addField('setPassword', setPasswordValidators);

    fv.registerValidator('checkPassword', strongPassword);

    // Validate password on password type
    const validateField = (setPassword) => {
      const field = fv.getFields(setPassword);
      if (field) {
        fv.validateField(setPassword);
      }
    };

    passwordField.addEventListener('input', () => {
      const fieldName = 'setPassword';
      validateField(fieldName);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  ['form-module', 'contact-form', 'newsletter-form'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleForm(form, formAction);
    }
  });
});
